export const bannerData = [
  {
    path: "/eyeglasses",
    title: {
      en: "EYE GLASSES",
      pt: "ÓCULOS",
    },
  },
  {
    path: "/sunglasses",
    title: {
      en: "SUN GLASSES",
      pt: "OCULOS DE SOL",
    },
  },
  {
    path: "/contact-lens",
    title: {
      en: "CONTACT LENSES",
      pt: "LENTES DE CONTATO",
    },
  },
  {
    path: "/brands",
    title: {
      en: "BRANDS",
      pt: "MARCAS",
    },
  },
  {
    path: "/exam",
    title: {
      en: "EYE EXAM",
      pt: "EXAME ÓPTICO",
    },
  },
];
